export default {
    meta: {
        title: '踩点记录-搜索地址'
    }
};
